import { reactive, computed } from 'vue'
import { messages } from '@/i18n/messages'

const DEFAULT_LOCALE = 'he' // default per product decision: Hebrew first

const state = reactive({
  locale: localStorage.getItem('todo_locale') || DEFAULT_LOCALE,
})

function dirFor(locale) {
  return locale === 'he' ? 'rtl' : 'ltr'
}

/** Apply direction + lang to <html>. Call on app boot and on every change. */
export function applyLocale() {
  const el = document.documentElement
  el.setAttribute('dir', dirFor(state.locale))
  el.setAttribute('lang', state.locale)
}

function setLocale(locale) {
  state.locale = locale
  localStorage.setItem('todo_locale', locale)
  applyLocale()
}

/**
 * Translate a dotted key, e.g. t('dashboard.open').
 * Falls back to English, then to the raw key. Supports {placeholder} params.
 */
function t(key, params = {}) {
  const dict = messages[state.locale] || messages.en
  const resolve = (d) => key.split('.').reduce((o, k) => (o && o[k] != null ? o[k] : null), d)
  let str = resolve(dict)
  if (str == null) str = resolve(messages.en)
  if (str == null) return key
  return str.replace(/\{(\w+)\}/g, (_, p) => (params[p] != null ? params[p] : `{${p}}`))
}

export function useI18n() {
  return {
    locale:      computed(() => state.locale),
    dir:         computed(() => dirFor(state.locale)),
    isRtl:       computed(() => state.locale === 'he'),
    setLocale,
    toggleLocale: () => setLocale(state.locale === 'he' ? 'en' : 'he'),
    applyLocale,
    t,
  }
}
